export const LogoMark = ({ className }) => (
    <svg viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true">
        <rect x="5" y="19" width="19" height="26" rx="2" stroke="currentColor" strokeWidth="4" />
        <circle cx="45" cy="32" r="11.5" stroke="#FF5E1A" strokeWidth="4" />
        <path d="M24 32h6" stroke="#00E5FF" strokeWidth="4" />
        <path d="M30 26l9 6-9 6z" fill="#00E5FF" />
    </svg>
);

export const Logo = ({ className = "" }) => (
    <span className={`inline-flex items-center gap-3 ${className}`}>
        <LogoMark className="h-8 w-8 text-white" />
        <span className="font-display text-2xl font-bold uppercase leading-none tracking-wide text-white">
            HITL<span className="text-blaze">.</span>partners
        </span>
    </span>
);
